module.exports = __webpack_public_path__ + "static/cardinal-puff-zoom-d40eedc2f11be5579ef4acb485b1021e.jpg";